import { ApiErrorResponseWithCode } from '@vfde-sails/utils';
import { Gigakombi, Device, Option, ProductType, OverlayView } from '../enum';

/**
 * Check if an object is an ApiErrorResponseWithCode
 * @param {unknown} error - object to check
 * @returns {boolean} - true if the object is an ApiErrorResponseWithCode
 */
export const isApiError = (error: unknown): error is ApiErrorResponseWithCode => {
    return null !== error
        && 'object' === typeof error
        && 'constructor' in error
        && error.constructor.name === ApiErrorResponseWithCode.name;
};

/**
 * Check if an object is a ProductType
 * @param {unknown} error - object to check
 * @returns {boolean} - true if the object is an ProductType
 */
export const isProductType = (value: unknown): value is ProductType =>
    Object.values(ProductType).includes(value as ProductType);

/**
 * Check if an object is a ProductOption
 * @param {unknown} error - object to check
 * @returns {boolean} - true if the object is an ProductOption
 */
export const isOption = (value: unknown): value is Option =>
    Object.values(Option).includes(value as Option);

/**
 * Check if an object is a ProductDevice
 * @param {unknown} error - object to check
 * @returns {boolean} - true if the object is an ProductDevice
 */
export const isDevice = (value: unknown): value is Device =>
    Object.values(Device).includes(value as Device);

/**
 * Check if an object is a Gigakombi
 * @param {unknown} value - object to check
 * @returns {boolean} - true if the param is a Gigakombi value
 */
export const isGigaKombi = (value: unknown): value is Gigakombi =>
    Object.values(Gigakombi).includes(value as Gigakombi);

/**
 * Check if an object is a member of OverlayView
 * @param {unknown} value - object to check
 * @returns {boolean} - true if the object is a member of OverlayView
 */
export const isOverlayView = (value: unknown): value is OverlayView =>
    Object.values(OverlayView).includes(value as OverlayView);
